import { Box, Grid } from "@mui/material";
import { ParagraphText, UBAppModal } from "../..";
import { LanguageContext } from "../../../context/LanguageContext";
import { useContext } from "react";
import styles from "./styles.module.css";

const KeyboardShortcutsModal = ({
  isOpen,
  handleClose,
  shortcuts = [],
  id = "keyboard_shortcuts",
  className = "",
}) => {
  const [I18n] = useContext(LanguageContext);
  const hasColumnAssignment = shortcuts.some(
    (item) => item?.column === "left" || item?.column === "right",
  );
  const midpoint = Math.ceil(shortcuts.length / 2);
  const leftColumnShortcuts = hasColumnAssignment
    ? shortcuts.filter((item) => item?.column === "left")
    : shortcuts.slice(0, midpoint);
  const rightColumnShortcuts = hasColumnAssignment
    ? shortcuts.filter((item) => item?.column === "right")
    : shortcuts.slice(midpoint);

  const renderShortcutKeys = (btnTitle) => {
    if (typeof btnTitle !== "string") {
      return <span className={styles.keycapText}>{btnTitle}</span>;
    }

    const parts = btnTitle
      .split("+")
      .map((part) => part.trim())
      .filter(Boolean);

    if (!parts.length) {
      return null;
    }

    const getKeycapSizeClass = (keyLabel) => {
      const normalized = keyLabel.trim().toLowerCase();
      if (normalized === "space") return styles.keycapLarge;
      if (normalized === "shift" || normalized === "enter") {
        return styles.keycapMedium;
      }
      return "";
    };

    return parts.map((part, index) => (
      <Box key={`${part}-${index}`} className={styles.keycapGroup}>
        <span className={`${styles.keycapText} ${getKeycapSizeClass(part)}`.trim()}>
          {part}
        </span>
        {index < parts.length - 1 && <span className={styles.keycapJoin}>+</span>}
      </Box>
    ));
  };

  const renderShortcutItem = (item, index) => (
    <div className={styles.shortcutItem} key={`${item.label}-${index}`}>
      <Box className={styles.shortcutLabelCol}>
        <ParagraphText className={styles.shortcutLabel}>
          {/* labelKey is translated where the language has it; Roman etc. fall back to the English label */}
          {(item.labelKey && I18n[item.labelKey]) || item.label}
        </ParagraphText>
      </Box>
      <Box className={styles.shortcutKeyCol}>
        <div className={styles.shortcutKeyBadge}>{renderShortcutKeys(item.btnTitle)}</div>
      </Box>
    </div>
  );

  return (
    <UBAppModal
      id="keyboard_shortcuts_modal"
      open={isOpen}
      className={`${styles.keyboardShortcutsModal} ${className}`.trim()}
      header={{
        title: (
          <ParagraphText className="d-flex align-items-center fontSize20 fontWeight500 newFontColor">
            {I18n.keyboard_shortcuts}
          </ParagraphText>
        ),
        handleClose,
        dont_show_cross_icon: true,
      }}
      footer={[
        {
          data: {
            onClick: handleClose,
            title: I18n.close,
            id: `${id}_close`,
            className: "buttonTeritary",
          },
        },
      ]}
    >
      <Box className={styles.content}>
        <Grid container className={styles.grid}>
          <Grid item xs={12} md={6} className={styles.gridColumn}>
            {leftColumnShortcuts.map(renderShortcutItem)}
          </Grid>
          <Grid item xs={12} md={6} className={`${styles.gridColumn} ${styles.gridColumnRight}`}>
            {rightColumnShortcuts.map(renderShortcutItem)}
          </Grid>
        </Grid>
      </Box>
    </UBAppModal>
  );
};

export default KeyboardShortcutsModal;
